<template>
	<div class="edu-manage">
		<div style="margin-bottom:15px">
			<el-button type="primary" @click.native="addEdu(1)">新增教育局</el-button>
		</div>

		<el-table border :data="eduList" size="small" style="margin-bottom:15px">
			<el-table-column prop="id" label="ID" />
			<el-table-column prop="eduName" label="教育局名称" />
			<el-table-column prop="level" label="级别" >
				<template slot-scope="scope">
						{{scope.row.level===0?'教育部':scope.row.level===1?'省厅':scope.row.level===2?'市教育局':'区县教育局'}}
					</template>
				</el-table-column>
			<el-table-column prop="address" label="所在地区" />
			<el-table-column prop="code" label="地区编码" />
			<el-table-column prop="phone" label="联系电话" />
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click.native="addEdu(2,scope.row)">编辑</el-button>
					<el-button size="mini" type="danger" @click.native="delEdu(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
			:page-size="pageSize" layout="total,prev, pager, next, jumper" :total="total">
		</el-pagination>

		<!-- 新增/编辑弹窗 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="600px" center>
			<el-form :model="form" label-width="100px">
				<el-form-item label="教育局名称">
					<el-input v-model="form.eduName" placeholder="请输入名称"></el-input>
				</el-form-item>

				<el-form-item label="教育局级别">
					<el-select v-model="form.level" placeholder="请选择级别" @change="getLevel">
						<el-option label="教育部" :value="0"></el-option>
						<el-option label="省教育厅" :value="1"></el-option>
						<el-option label="市教育局" :value="2"></el-option>
						<el-option label="区县教育局" :value="3"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="省份">
					<el-select v-model="form.province" @change="getCities" placeholder="请选择省" filterable>
						<el-option v-for="p in provinceList" :key="p.id" :label="p.name"
							:value="p.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="城市">
					<el-select v-model="form.city" @change="getAreas" placeholder="请选择市" filterable :disabled="cityList.length==0">
						<el-option v-for="c in cityList" :key="c.id" :label="c.name" :value="c.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="区县">
					<el-select v-model="form.area" placeholder="请选择区县" @change="getT" filterable :disabled="areaList.length==0">
						<el-option v-for="a in areaList" :key="a.id" :label="a.name" :value="a.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="地区编码">
					<el-input v-model="form.code" placeholder="请输入编码" disabled></el-input>
				</el-form-item>

				<el-form-item label="详细地址">
					<el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
				</el-form-item>

				<el-form-item label="联系人">
					<el-input v-model="form.contact" placeholder="联系人"></el-input>
				</el-form-item>

				<el-form-item label="联系电话">
					<el-input v-model="form.phone" placeholder="电话"></el-input>
				</el-form-item>

				<el-form-item label="状态">
					<el-select v-model="form.status" placeholder="状态">
						<el-option label="正常" :value="0"></el-option>
						<el-option label="禁用" :value="1"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer">
				<el-button @click="dialogVisible=false">取消</el-button>
				<el-button type="primary" @click="saveEdu">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getRegion } from "@/js/standard.js";
	export default {
		
		data() {
			return {
				eduList: [],
				pageNum: 1,
				pageSize: 10,
				total: 2,
				title: '',
				dialogVisible: false,
				currentType: 1,
				codeList:[1,0,0,0],
				form: {
					eduName: '',
					level: 0,
					province: '',
					city: '',
					area: '',
					address: '',
					code: '',
					contact: '',
					phone: '',
					status: 0
				},
				provinceList: [],
				cityList: [],
				areaList: []
			}
		},
		created() {
			this.getProvinces()
			this.getEduList()
		},

		methods: {
			getEduList(){
				this.eduList=[]
				this.API.get(this.API.admin.getEduList,{
					pageNum:this.pageNum,
					pageSize:this.pageSize
				}).then(res=>{
					this.eduList=res.data.data.records
					this.total=res.data.data.total
				})
				
			},
			getProvinces() {
				if(this.provinceList.length===0){
					this.getRegionList(1,1)
				}
				
			},
			async getRegionList(level,id) {
				let api=this
				if(level===1){
					this.provinceList=await getRegion(api,level,id)
					console.log('this.provinceList',this.provinceList)
				}else if(level===2){
					this.cityList=await getRegion(api,level,id)
				}else if(level===3){
					this.areaList=await getRegion(api,level,id)
				}
			},
			getLevel(level){
				this.forcode()
			},
			forcode(){
				var level=this.form.level
				
				if(level===1){
					if(this.provinceList.length>0){
						this.form.code=this.provinceList.filter(v=>v.id===this.codeList[1])[0].adcode
					}
				}else if(level===2&&this.cityList.length>0){
					this.form.code=this.cityList.filter(v=>v.id===this.codeList[2])[0].adcode
				}else if(level===3&&this.areaList.length>0){
					this.form.code=this.areaList.filter(v=>v.id===this.codeList[3])[0].adcode
				}else{
					this.form.code=100000
				}
			},
			getCities(id,status) {
				this.getRegionList(2,id)
				if(!status){
					this.form.city = ''
					this.form.area = ''
					this.cityList = []
					this.areaList=[]
					this.codeList[1]=id
					this.codeList[2]=0
					this.codeList[3]=0
					this.forcode()
				}
			},
			getAreas(id,status) {
				if(!status){
					this.form.area = ''
					this.areaList = []
					this.codeList[2]=id
					this.codeList[3]=0
					this.forcode()
				}
				this.getRegionList(3,id)
			},
			getT(id){
				this.codeList[3]=id
				this.forcode()
			},
			addEdu(type, row) {
				this.currentType = type
				if (type === 1) {
					this.title = '新增教育局'
					this.form = {
						eduName: '',
						level: 0,
						province: '',
						city: '',
						area: '',
						address: '',
						code: '100000',
						contact: '',
						phone: '',
						status: 0
					}
					this.codeList=[1,0,0,0]
					this.cityList = []
					this.areaList = []
					this.dialogVisible = true
				} else {
					this.title = '修改教育局'
					this.form = {
						id:row.id,
						eduName:row.eduName,
						level: row.level,
						province:Number(row.province),
						city:Number(row.city),
						area:Number(row.area),
						address: row.address,
						code: row.code,
						contact:row.contact,
						phone: row.phone,
						// parentId:row.parentId || '',
						status: row.status
					}
					this.getCities(Number(row.province),1)
					this.getAreas(Number(row.city),1)
					this.$nextTick(()=>{
						this.dialogVisible = true
					})
				}
				
			},
			isFormValid(obj) {
			  // 遍历对象所有属性
			  for (let key in obj) {
			    // 如果是 null / undefined / 空字符串，直接返回 false
			    if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
					console.log('key',key)
			      return false
			    }
			  }
			  return true
			},
			saveEdu() {
				const levelMap = {
					0: '教育部',
					1: '省厅',
					2: '市局',
					3: '区县'
				}
				let form=this.form
				let isForm=this.isFormValid(this.form)
				if(!isForm) return this.$message.error('信息未填写完整')
				if(this.currentType===1){
					this.API.post(this.API.admin.postEduAdd,{
						eduName:form.eduName,
						level:form.level,
						parentId:form.parentId,
						province:form.province,
						city:form.city,
						area:form.area,
						address:form.address,
						code:form.code,
						contact:form.contact,
						phone:form.phone,
						status:0
					}).then(res=>{
						this.$message.success('添加成功')
						this.pageNum=1
						this.getEduList()
						this.dialogVisible = false
					})
				}else{
					this.API.put(this.API.admin.putEduUpdate,{
						id:form.id,
						eduName:form.eduName,
						level:form.level,
						parentId:form.parentId,
						province:form.province,
						city:form.city,
						area:form.area,
						address:form.address,
						code:form.code,
						contact:form.contact,
						phone:form.phone,
						status:form.row
					}).then(res=>{
						this.$message.success('添加成功')
						this.pageNum=1
						this.getEduList()
						this.dialogVisible = false
					})
				}
				
				
			},

			delEdu(id) {
				this.$confirm('确定删除？', '提示', {
					type: 'warning'
				}).then(() => {
					this.eduList = this.eduList.filter(x => x.id !== id)
					this.total = this.eduList.length
					this.$message.success('删除成功')
				})
			},

			handleSizeChange(val) {
				this.pageSize = val
			},
			handleCurrentChange(val) {
				this.pageNum = val
			}
		}
	}
</script>